import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataExchangeCommentDto } from 'src/app/data-transfer/entities/data-exchange-request-entities/data-exchange-comment-dto';

export interface SubRequestCommentsDialogData {
  comments: DataExchangeCommentDto[] | null | undefined;
  title: string;
}

@Component({
  selector: 'app-sub-request-comments-dialog',
  templateUrl: './sub-request-comments-dialog.component.html',
  styleUrls: ['./sub-request-comments-dialog.component.scss']
})
export class SubRequestCommentsDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<SubRequestCommentsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SubRequestCommentsDialogData
  ) {}

  onCommentAdded(text: string): void {
    this.dialogRef.close(text);
  }
}
